module.exports = __webpack_public_path__ + "static/img/hot_icon.005c57d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/hot_icon.gif
// module id = SPNo
// module chunks = 0